//export const baseUrl = "https://whitelabel.admin.theassetmanager.co.uk/api/v1";
//export const baseUrl = "http://localhost:3002/api/v1";
export const baseUrl = process.env.BASE_URL || "https://whitelabel.admin.theassetmanager.co.uk/api/v1";
